import {Component, ViewChild} from '@angular/core';
import {Nav, Platform} from 'ionic-angular';
import {StatusBar} from '@ionic-native/status-bar';
import {SplashScreen} from '@ionic-native/splash-screen';
import {Events} from 'ionic-angular';
@Component({
    templateUrl: 'app.html'
})
export class MyApp {
    @ViewChild(Nav) nav: Nav;

    rootPage: string = localStorage.getItem('token')?'HomePage':'LoginPage'; 

    pages: Array<{title: string, component: any}>;

    constructor(public platform: Platform, public statusBar: StatusBar, public splashScreen: SplashScreen, public events: Events) {
        this.initializeApp();

        // used for an example of ngFor and navigation
        this.pages = [
            {title: 'Home', component: 'HomePage'},
            {title: 'View Subject', component: 'ViewSubjectPage'},
            {title: 'View Result', component: 'ViewResultPage'},
            {title: 'Upgrade Class/Sem', component: 'UpgradePage'},
            {title: 'Logout', component: 'Logout'},
        ];

    }


    initializeApp() {
        this.platform.ready().then(() => {
            // Okay, so the platform is ready and our plugins are available.
            // Here you can do any higher level native things you might need.
            this.statusBar.styleDefault();
            this.splashScreen.hide();
        });
        
        this.events.subscribe('redirect:LoginPage', (val) => {
           if (val) {
               this.nav.setRoot('LoginPage');
           }
       }) 
        
    }

    openPage(page) {
        // Reset the content nav to have just this page
        // we wouldn't want the back button to show in this scenario
        this.nav.setRoot(page.component);
    }
    
    
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts